module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        return _vm.editInfo()
      }
    }
  }, [_vm._v("添加会员等级")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.memberData,
      "height": _vm.wheight - 210
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "label": "全选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "member_lv_id",
      "label": "ID",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "等级名称",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "member_lv",
      "label": "会员等级",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "等级logo",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "placement": "right",
            "width": "240",
            "trigger": "hover"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "src": scope.row.lv_logo
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "slot": "reference",
            "type": "text"
          },
          slot: "reference"
        }, [_c('img', {
          staticStyle: {
            "width": "50px",
            "height": "50px"
          },
          attrs: {
            "src": scope.row.lv_logo
          }
        })])], 1)]
      }
    }], null, false, 3534374885)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "att_ratio",
      "label": "分佣比例",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "new_reward",
      "label": "拉新奖励",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "min_withdraw",
      "label": "最低提现",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lv_remark",
      "label": "会员等级备注",
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "btn-gap",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editInfo(scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }], null, false, 2727074055)
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": _vm.dialogTitle,
      "visible": _vm.editInfoDialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editInfoDialog = $event
      }
    }
  }, [
    [_c('el-form', [_c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "等级名称"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "等级名称"
      },
      model: {
        value: (_vm.updateForm.name),
        callback: function($$v) {
          _vm.$set(_vm.updateForm, "name", $$v)
        },
        expression: "updateForm.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "会员等级"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "会员等级"
      },
      model: {
        value: (_vm.updateForm.member_lv),
        callback: function($$v) {
          _vm.$set(_vm.updateForm, "member_lv", $$v)
        },
        expression: "updateForm.member_lv"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "等级logo",
        "prop": "lv_logo"
      }
    }, [_c('div', {
      staticClass: "upload-box",
      on: {
        "click": function($event) {
          return _vm.handleImgPicker('lv_logo')
        }
      }
    }, [(_vm.updateForm.lv_logo) ? _c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.updateForm.lv_logo
      }
    }) : _c('i', {
      staticClass: "iconfont icon-camera avatar-uploader-icon"
    })])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "分佣比例"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "分佣比例"
      },
      model: {
        value: (_vm.updateForm.att_ratio),
        callback: function($$v) {
          _vm.$set(_vm.updateForm, "att_ratio", $$v)
        },
        expression: "updateForm.att_ratio"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "拉新奖励"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "拉新奖励"
      },
      model: {
        value: (_vm.updateForm.new_reward),
        callback: function($$v) {
          _vm.$set(_vm.updateForm, "new_reward", $$v)
        },
        expression: "updateForm.new_reward"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "最低提现"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "最低提现"
      },
      model: {
        value: (_vm.updateForm.min_withdraw),
        callback: function($$v) {
          _vm.$set(_vm.updateForm, "min_withdraw", $$v)
        },
        expression: "updateForm.min_withdraw"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label-width": "100px",
        "label": "会员等级备注"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "会员等级备注"
      },
      model: {
        value: (_vm.updateForm.lv_remark),
        callback: function($$v) {
          _vm.$set(_vm.updateForm, "lv_remark", $$v)
        },
        expression: "updateForm.lv_remark"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticClass: "content-center"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.editInfoSubmit()
        }
      }
    }, [_vm._v("确定")])], 1)], 1)]
  ], 2), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76956420", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76956420"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/sharer/memberLv/list.vue
// module id = 2836
// module chunks = 0